import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const VaticanCity: Country = {
    identifier: "VaticanCity",
    name: "Vatican City",
    countryCode: "VA",
    group: CountryGroup.EUROPE,
    isUNMember: false,
    flag: "🇻🇦",
    svgPath: "m 509.80575,333.9114 -0.024,0.003 -0.009,-0.013 0.009,-0.017 0.021,-0.003 z",
}
